import React from 'react'
import { HeroPanel, DetailTilesContainer, EnvironmentTitle, BannerTilesGroup, BannerStatusTile } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'
import { useSelector } from 'react-redux'
import { issuerOrganisationsDetailsSelector } from 'selectors/issuerOrganisationSelectors'
import { useDispatch } from 'react-redux'

export const IssuerOrganisationsHeroPanel: React.FC = () => {
  const dispatch = useDispatch()
  const issuerOrganisations = useSelector(issuerOrganisationsDetailsSelector)

  return (
    <HeroPanel onTearout={() => dispatch(WindowActions.tearoutGrid('/quote/tearout/admin/issuerOrganisations'))}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'IssuerOrganisations-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_ISSUER_ORGANISATIONS)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={issuerOrganisations.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}
